import { Factory } from 'rosie'; // eslint-disable-line import/no-extraneous-dependencies

Factory.define('examAccessToken')
  .attrs({
    exam_access_token: 'Z173480948902JK34432',
    exam_access_token_expiration: '60',
  });
